export const TEST_ACTION = 'TEST_ACTION' as const;
